<!-- EDIT CONTACTS OF COMPANY -->
<div *ngIf="inputCompany != null">
  <mat-dialog-content>
    <h2>{{ inputCompany.name }}: Bewerk contacten</h2>
    <mat-form-field appearance="outline">
      <mat-label>Zoek contact</mat-label>

      <input
        type="text"
        matInput
        placeholder="Naam"
        [matAutocomplete]="auto"
        [(ngModel)]="contactSearchTerm"
        (ngModelChange)="onContactSearchTermChanged($event)"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="contactSelected($event.option)"
        [panelWidth]="500"
      >
        <mat-option *ngFor="let item of contactSearchResult" [value]="item">
          {{ getContactLabel(item) }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <div *ngIf="displayedContacts == null || displayedContacts.length === 0">
      <p class="no-margin padding-bottom">
        Geen contacten gedefinieerd
      </p>
    </div>
    <div
      *ngFor="let contact of displayedContacts"
      class="d-flex justify-content-between"
    >
      <mat-form-field class="first-form-field no-margin" appearance="outline">
        <mat-label>Naam</mat-label>
        <input
          matInput
          type="text"
          value="{{ contact.firstName + ' ' + contact.lastName }}"
          [placeholder]="'Naam'"
          disabled
        />
      </mat-form-field>
      <mat-form-field class="form-field no-margin" appearance="outline">
        <mat-label>Telefoonnummer</mat-label>
        <input
          matInput
          type="text"
          value="{{
            contact.telephones[0] &&
              formatPhoneNumber.transform(contact.telephones[0].number)
          }}"
          [placeholder]="'Telefoonnummer'"
          disabled
        />
      </mat-form-field>
      <mat-form-field class="form-field no-margin" appearance="outline">
        <mat-label>E-mailadres</mat-label>
        <input
          matInput
          type="text"
          value="{{ contact.emails[0] && contact.emails[0].email }}"
          [placeholder]="'E-mailadres'"
          disabled
        />
      </mat-form-field>
      <div
        class="flexer box clickable push-down"
        (click)="deleteContact(contact)"
      >
        <mat-icon svgIcon="close" class="delete-button"></mat-icon>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="float-right">
    <button
      type="button"
      (click)="save()"
      mat-button
      class="button"
      id="btnSave"
    >
      Opslaan
    </button>
  </mat-dialog-actions>
</div>

<!-- EDIT COMPANIES OF CONTACT -->
<div *ngIf="inputContact != null">
  <mat-dialog-content>
    <h2>{{ getContactPrintName(inputContact) }}: Bewerk bedrijven</h2>
    <mat-form-field appearance="outline">
      <mat-label>Zoek bedrijf</mat-label>

      <input
        type="text"
        matInput
        placeholder="Naam"
        [matAutocomplete]="auto"
        [(ngModel)]="companySearchTerm"
        (ngModelChange)="onCompanySearchTermChanged($event)"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="companySelected($event.option)"
        [panelWidth]="500"
      >
        <mat-option *ngFor="let item of companySearchResult" [value]="item">
          {{ item.regularName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <div *ngIf="displayedCompanies == null || displayedCompanies.length === 0">
      <p class="no-margin padding-bottom">
        Geen bedrijven gedefinieerd
      </p>
    </div>
    <div
      *ngFor="let company of displayedCompanies"
      class="d-flex justify-content-between"
    >
      <mat-form-field class="first-form-field no-margin" appearance="outline">
        <mat-label>Naam</mat-label>
        <input
          matInput
          type="text"
          value="{{ company.regularName }}"
          [placeholder]="'Naam'"
          disabled
        />
      </mat-form-field>
      <mat-form-field class="form-field no-margin" appearance="outline">
        <mat-label>Telefoonnummer</mat-label>
        <input
          matInput
          type="text"
          value="{{
            company.telephones[0] &&
              formatPhoneNumber.transform(company.telephones[0].number)
          }}"
          [placeholder]="'Telefoonnummer'"
          disabled
        />
      </mat-form-field>
      <mat-form-field class="form-field no-margin" appearance="outline">
        <mat-label>E-mailadres</mat-label>
        <input
          matInput
          type="text"
          value="{{ company.emails[0] && company.emails[0].email }}"
          [placeholder]="'E-mailadres'"
          disabled
        />
      </mat-form-field>
      <div
        class="flexer box clickable push-down"
        (click)="deleteCompany(company)"
      >
        <mat-icon svgIcon="close" class="delete-button"></mat-icon>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="float-right">
    <button
      type="button"
      (click)="save()"
      mat-button
      class="button"
      id="btnSave"
    >
      Opslaan
    </button>
  </mat-dialog-actions>
</div>
